import {
  Inconsistency5SFilesActions,
  Inconsistency5SFilesActionTypes,
  Inconsistency5SFilesState,
} from '../../types/inconsistency5SFiles';

const initialState: Inconsistency5SFilesState = {};

const ensureBucket = (state: Inconsistency5SFilesState, id: number) =>
  state[id] || { files: [], loading: false, error: null };

export const inconsistency5SFiles = (
  state = initialState,
  action: Inconsistency5SFilesActions,
): Inconsistency5SFilesState => {
  switch (action.type) {
    case Inconsistency5SFilesActionTypes.FETCH_REQUEST: {
      const { inconsistencyId } = action.payload;
      const bucket = ensureBucket(state, inconsistencyId);
      return {
        ...state,
        [inconsistencyId]: { ...bucket, loading: true, error: null },
      };
    }

    case Inconsistency5SFilesActionTypes.FETCH_SUCCESS: {
      const { inconsistencyId, files } = action.payload;
      const bucket = ensureBucket(state, inconsistencyId);
      const pending = bucket.files.filter((f) => f.isUploading);
      return {
        ...state,
        [inconsistencyId]: { files: [...files, ...pending], loading: false, error: null },
      };
    }

    case Inconsistency5SFilesActionTypes.FETCH_FAILURE: {
      const { inconsistencyId, error } = action.payload;
      const bucket = ensureBucket(state, inconsistencyId);
      return {
        ...state,
        [inconsistencyId]: { ...bucket, loading: false, error },
      };
    }

    case Inconsistency5SFilesActionTypes.UPLOAD_REQUEST: {
      const { inconsistencyId, file, tempId } = action.payload;
      const bucket = ensureBucket(state, inconsistencyId);
      const placeholder = {
        name: file.name,
        sizeBytes: file.size,
        isUploading: true,
        tempId,
      };
      return {
        ...state,
        [inconsistencyId]: { ...bucket, files: [...bucket.files, placeholder] },
      };
    }

    case Inconsistency5SFilesActionTypes.UPLOAD_SUCCESS: {
      const { inconsistencyId, tempId, file } = action.payload;
      const bucket = ensureBucket(state, inconsistencyId);
      return {
        ...state,
        [inconsistencyId]: {
          ...bucket,
          files: bucket.files.map((f) => (f.tempId === tempId ? file : f)),
        },
      };
    }

    case Inconsistency5SFilesActionTypes.UPLOAD_FAILURE: {
      const { inconsistencyId, tempId, error } = action.payload;
      const bucket = ensureBucket(state, inconsistencyId);
      return {
        ...state,
        [inconsistencyId]: {
          ...bucket,
          files: bucket.files.filter((f) => f.tempId !== tempId),
          error,
        },
      };
    }

    case Inconsistency5SFilesActionTypes.DELETE_REQUEST: {
      const { inconsistencyId } = action.payload;
      const bucket = ensureBucket(state, inconsistencyId);
      return {
        ...state,
        [inconsistencyId]: { ...bucket, error: null },
      };
    }

    case Inconsistency5SFilesActionTypes.DELETE_SUCCESS: {
      const { inconsistencyId, recordDocumentId } = action.payload;
      const bucket = ensureBucket(state, inconsistencyId);
      return {
        ...state,
        [inconsistencyId]: {
          ...bucket,
          files: bucket.files.filter((f) => f.recordDocumentId !== recordDocumentId),
        },
      };
    }

    case Inconsistency5SFilesActionTypes.DELETE_FAILURE: {
      const { inconsistencyId, error } = action.payload;
      const bucket = ensureBucket(state, inconsistencyId);
      return {
        ...state,
        [inconsistencyId]: { ...bucket, error },
      };
    }

    default:
      return state;
  }
};
